module.exports = __webpack_public_path__ + "img/Shiprocket GS.769569a1.svg";